import CircularProgress from "@mui/joy/CircularProgress";
import Dropdown from "@mui/joy/Dropdown";
import Menu from "@mui/joy/Menu";
import MenuButton from "@mui/joy/MenuButton";
import MenuItem from "@mui/joy/MenuItem";
import React from "react";
import { useNavigate } from "react-router-dom";
import { CohortId, ExportFormat } from "../../../models/cohort";
import { useSnackbar } from "../../../shared/components/layout/SnackbarContext";
import { OmopQuartzClientContext } from "../../../shared/services/api/contexts";

interface ExportDropDownProps {
  readonly cohortId: CohortId;
}

export default function ExportDropDown({ cohortId }: ExportDropDownProps) {
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const omopClient = React.useContext(OmopQuartzClientContext);

  const [exportLoading, setExportLoading] = React.useState<boolean>(false);

  const handleExport = async (
    exportFormat: ExportFormat,
    cohortId: CohortId,
    dateFormat?: string
  ) => {
    setExportLoading(true);
    try {
      await omopClient.exportOmop(exportFormat, undefined, cohortId, undefined, dateFormat);
    } catch (e: any) {
      console.error(e);
      showSnackbar({ text: e.message, color: "danger" });
    } finally {
      setExportLoading(false);
    }
  };

  return (
    <Dropdown>
      <MenuButton
        variant="solid"
        color="primary"
        startDecorator={exportLoading && <CircularProgress />}
        disabled={exportLoading}
      >
        Export
      </MenuButton>
      <Menu placement="bottom-end">
        <MenuItem onClick={() => handleExport(ExportFormat.CSV, cohortId)}>OMOP (CSV)</MenuItem>
        <MenuItem onClick={() => handleExport(ExportFormat.SQLITE, cohortId)}>
          OMOP (SQLite)
        </MenuItem>
        <MenuItem onClick={() => navigate(`/cohort/${cohortId}/export`)}>Custom export</MenuItem>
      </Menu>
    </Dropdown>
  );
}
